export const DAIRY_START_MONITOR_APPLICATION_KEY = 'DairyStartMonitor';
